import { render } from "./adminsix.vue?vue&type=template&id=73338046&scoped=true"
import script from "./adminsix.vue?vue&type=script&lang=js"
export * from "./adminsix.vue?vue&type=script&lang=js"

import "./adminsix.vue?vue&type=style&index=0&id=73338046&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73338046"]])

export default __exports__